import { Tabs } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import DayButton from './DayButton';

const mapStateToProps = (state) => ({ workdays: state.timecard.workdays });
const DayNavigator = ({ workdays, activeDay, setActiveDay, showPriorButton }) => {
  return (
    <Tabs value={0} variant="scrollable" scrollButtons="auto">
      {showPriorButton && (
        <DayButton isPrior={true} activeDay={activeDay} setActiveDay={setActiveDay} />
      )}
      {workdays.map((workday, index) => (
        <DayButton
          key={index}
          workday={workday}
          activeDay={activeDay}
          setActiveDay={setActiveDay}
        />
      ))}
    </Tabs>
  );
};

export default connect(mapStateToProps)(DayNavigator);
